import { atom } from 'recoil'

export const editorState = atom({
  key: 'editRowEditorState',
  default: {
    dirty: false,
    saved: true,
    thirdPartyAccepted: false,
    saveToLists: [],
    rowDetails: {
      category: undefined,
      hasThumbnail: undefined,
      id: undefined,
      thumbnail: undefined,
      title: undefined,
      type: undefined,
      structure: undefined
    },
    mergeTags: [],
    mergeTagsWhitelist: [],
    idNewRow: 0, // id del nuovo template, forza il reload
    exitAfertSave: false,
    afterSaveCallback: undefined
  }
})

export const beePluginState = atom({
  key: 'rowEditBeePluginState',
  default: {
    instance: undefined,
    loaded: false
  }
})

export const openAIState = atom({
  key: 'rowEditBeePluginidopenAIState',
  default: {
    totalTokens: null,
    remainingTokens: null,
    enableUse: false,
    showBuy: false,
    loaded: false
  }
})
